<app-page>
  <diamond-posts></diamond-posts>
</app-page>
